import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const data = {
  title: 'Social Media',
  subtitle: 'Optimization (SMO)',
  tagline: 'Maximize Your Organic Reach',
  // icon: '🔍',
  icon: '',

  heroDesc: 'Optimize your social media profiles to rank higher, attract more followers organically, and build a powerful brand presence without paid advertising.',
  mainStat: '60%',
  mainStatLabel: 'Average increase in organic reach after SMO',
  subStats: [{ value: '93+', label: 'Profiles Optimized' }, { value: '2x', label: 'Avg Profile Visits' }],
  features: [
    { icon: '🏷️', title: 'Profile Optimization', desc: 'Complete bio, keywords, and profile setup optimized for discoverability.' },
    { icon: '#️⃣', title: 'Hashtag Strategy', desc: 'Research-backed hashtag sets that put your content in front of the right people.' },
    { icon: '🔗', title: 'Link & Bio Setup', desc: 'Optimized link-in-bio, highlights, and call-to-action buttons.' },
    { icon: '📸', title: 'Visual Branding', desc: 'Consistent color palettes, fonts, and grid aesthetics that build brand recognition.' },
    { icon: '📅', title: 'Optimal Posting Times', desc: 'Data-driven posting schedules based on your audience\'s most active hours.' },
    { icon: '🤝', title: 'Engagement Tactics', desc: 'Proven techniques to boost comments, shares, saves, and follower interaction.' },
  ],
  benefits: [
    { title: 'Grow Without Paid Ads', desc: 'Organic growth through smart optimization — no ad budget required.' },
    { title: 'Better Profile Discoverability', desc: 'Your profile appears in more searches and suggested accounts.' },
    { title: 'Higher Content Reach', desc: 'Optimized posts reach beyond your existing followers.' },
    { title: 'Stronger Brand Identity', desc: 'Professional, consistent profiles that build instant credibility.' },
  ],
  process: [
    { title: 'Profile Audit', desc: 'Complete analysis of your existing profiles to identify gaps and opportunities.' },
    { title: 'Competitor Research', desc: 'We study top performers in your niche to find what\'s working.' },
    { title: 'Full Profile Overhaul', desc: 'Bio, profile picture, highlights, links, and keywords all optimized.' },
    { title: 'Content Optimization', desc: 'Implement optimal hashtags, captions, and formats for each platform.' },
    { title: 'Ongoing Monitoring', desc: 'Track reach, impressions, and follower growth with monthly reports.' },
  ],
  whyChoose: [
    { icon: '📊', title: 'Proven Results', desc: 'Clients see measurable improvement in reach and engagement within weeks.' },
    { icon: '🧠', title: 'Deep Expertise', desc: 'We stay updated on algorithm changes to keep your strategy ahead.' },
    { icon: '🎨', title: 'Aesthetic Branding', desc: 'Beautiful, consistent profiles that make a strong first impression.' },
    { icon: '💡', title: 'Holistic Strategy', desc: 'SMO combined with content strategy for maximum organic impact.' },
  ],
  reviews: [
    { name: 'Pooja Singh', role: 'Boutique Owner', text: 'My Instagram went from invisible to getting daily DMs from new customers. Incredible work!' },
    { name: 'Suresh Nair', role: 'Real Estate Agent', text: 'DMS optimized my LinkedIn profile and now I get 5x more profile visits every week.' },
    { name: 'Kavita Joshi', role: 'Yoga Instructor', text: 'They transformed my Instagram into a professional-looking brand that people trust instantly.' },
  ],
  faq: [
    { q: 'What is the difference between SMO and SMM?', a: 'SMO (Optimization) focuses on improving your profile setup and organic reach, while SMM (Marketing) is ongoing content creation and management.' },
    { q: 'Is SMO a one-time service?', a: 'The initial optimization is a one-time project, but we recommend ongoing monthly check-ins to adapt to algorithm changes.' },
    { q: 'Will SMO help with follower growth?', a: 'Yes — optimized profiles are discovered more easily, leading to steady organic follower growth over time.' },
  ],
};

export default function SocialMediaOptimization() {
  return <ServiceTemplate data={data} />;
}
